import { render, staticRenderFns } from "./examineBzj.vue?vue&type=template&id=330c8afa&scoped=true"
import script from "./examineBzj.vue?vue&type=script&lang=js"
export * from "./examineBzj.vue?vue&type=script&lang=js"
import style0 from "./examineBzj.vue?vue&type=style&index=0&id=330c8afa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330c8afa",
  null
  
)

export default component.exports